export { default } from "./DispensariesCarousel";
